import React from 'react'
import { linkResolver } from './linkResolver'

export const repositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_MAIN_REPOSITORY_NAME,
    linkResolver,
    componentResolver: {
      event: React.lazy(() => import('../templates/event')),
      page: React.lazy(() => import('../templates/page')),
      venue: React.lazy(() => import('../templates/venue')),
      news_article: React.lazy(() => import('../templates/newsArticle'))
    }
  }
]
